import { Entity } from "./entity";
import { ProductMake, ProductType, SparepartStatus } from "./enum-type";

export interface SparePart extends Entity {
    frenchName: string
    price: string
    unitInStock: number
    minUnitInStock: number
    reference: string
    notificationEnabled: boolean
    sparepartType: ProductType
    sparepartStatus: SparepartStatus
    sparepartMake: ProductMake
    command: string
    stockValue: string
    displayName?: string
}

export class SparePartExport {
    parts: SparePart[];
}

export function getSparePartExport(spareparts: SparePart[]): SparePartExport {
    const sparePartExport = new SparePartExport();
    sparePartExport.parts = spareparts;
    return sparePartExport;
}